import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitCommits } from '@/services/git/api';
import type { GitCommit } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitCommits(
  repoFullName: string | null | undefined,
  branch: string | null | undefined,
): UseQueryResult<GitCommit[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitCommits', orgId, repoFullName, branch],
    queryFn: () => fetchGitCommits(orgId!, repoFullName!, branch!),
    enabled: !!token && !!orgId && !!repoFullName && !!branch,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    meta: { silent: true },
  });
}
